import React from 'react';
import { History } from 'history';
import { Input, InputEmail, InputFile, InputMultiline, InputSwitch } from '../../components';
import BaseDelete from '../base/base-delete.component'; 
import Model from './owner-model';  //editable..

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class OwnerDelete extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }
    
    render() {
        return (
            //editable..
            <BaseDelete history={this.props.history} 
                model={Model} onLoad={this.onLoad}>              
                
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly/>
                <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                <Input name='phone' label='Phone' value={this.state.datarow.phone} readOnly/>
                <InputEmail name='email' label='Email' value={this.state.datarow.email} readOnly/>
                <InputMultiline name='address' label='Address' value={this.state.datarow.address} readOnly/>
                <InputFile name='imageUrl' label='Logo' value={this.state.datarow.imageUrl} type='image' readOnly/>
            </BaseDelete>
        );
    }
}